import React, { Component } from 'react'
import PropTypes from 'prop-types'

const styleSheet = {
  container: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    opacity: 0,
    transition: '.2s',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10 ** 20,
    display: 'flex',
    overflow: 'auto',
  },
  content: {
    margin: 'auto',
    zIndex: 10 ** 21,
  }
}

class Modal extends Component {
  static propTypes = {
    display: PropTypes.bool,
    hide: PropTypes.func.isRequired,
  }

  state = {
    container: null,
    rendered: false
  }

  componentDidMount() {
    document.addEventListener('keypress', this.keypress)
  }

  componentWillUnmount() {
    document.removeEventListener('keypress', this.keypress)
  }

  keypress = event => {
    if (! this.props.display || ! this.props.hide)
      return

    if (event.which === 13 || event.keyCode === 13 || event.code === 'Enter') {
      event.preventDefault()
      event.stopPropagation()
      return this.props.hide()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (! this.props.display && nextProps.display) {
      setTimeout(() => {
        this.setState({
          rendered: true
        })
      }, 100)
    }
    if (this.props.display && ! nextProps.display) {
      setTimeout(() => {
        this.setState({
          rendered: false
        })
      })
    }
  }

  render() {
    const { display, children, color, unStyled, onlyHide } = this.props

    if (! display && ! onlyHide) {
      return <span style={{ position: 'fixed', zIndex: -1 }}/>
    }

    let style = {
      content: styleSheet.content,
      container: styleSheet.container
    }

    if (color) {
      style.container = {
        ...style.container,
        backgroundColor: color
      }
    }

    if (this.state.rendered) {
      style.container = {
        ...style.container,
        opacity: 1
      }
    }

    if (unStyled) {
      style.content = {
      }
    }

    if (! display) {
      style.container = {
        ...style.container,
        display: 'none'
      }
    }

    return (
      <div style={style.container} onClick={this.hide} ref={this.createContainerRef} data-component-name="Modal">
        <div style={style.content}>
          {typeof children === 'function' ? children() : children}
        </div>
      </div>
    )
  }

  hide = event => {
    const { hide, closeOnClick } = this.props

    if (! hide) {
      return
    }

    if (! closeOnClick) {
      if (event.target !== this.state.container) {
        return
      }
    }

    if (closeOnClick) {
      event.stopPropagation()
    }

    event.preventDefault()
    hide()
  }

  createContainerRef = element => {
    if (this.state.container === element) {
      return
    }

    this.setState({
      container: element
    })
  }
}

Modal.example = class extends Component {
  state = { visible: false }

  render() {
    const c = this.props.components

    return (
      <c.OuterContainer>
        <c.Button onClick={this.toggleModal}>Open modal</c.Button>
        <Modal display={this.state.visible} color="rgba(0, 0, 0, 0.7)" hide={this.toggleModal}>
          <c.Container color="white" padded rounded>
            I am a modal! I can look however you like. The shade color is configurable
            through the color property and the content of the modal is vertically
            and horizontally centered.
            <br/>
            <br/>
            {`
                <Modal display={boolean} color={string} hide={function}/>
            `}
          </c.Container>
        </Modal>
      </c.OuterContainer>
    )
  }

  toggleModal = () => {
    this.setState({
      visible: ! this.state.visible
    })
  }
}

export default Modal



// WEBPACK FOOTER //
// ./src/components/Modal.js